import { TransferItem } from '../../../services/xbitRelayTransfersService';

// approve/reject/mark-done are verified LOCALLY in wallet via verifyAdminSignature, which reuses
// buildWithdrawalSignMessage — hence the literal 'Withdrawal ID:' prefix (NOT 'Transfer ID:').
// The transfer id fills the <id> slot.
export const buildApproveMessage = (id: string, timestampMs: number) =>
  `Withdrawal ID: ${id}\nAction: Approve\nTimestamp: ${timestampMs}`;

export const buildRejectMessage = (id: string, timestampMs: number) =>
  `Withdrawal ID: ${id}\nAction: Reject\nTimestamp: ${timestampMs}`;

export const buildMarkDoneMessage = (id: string, timestampMs: number) =>
  `Withdrawal ID: ${id}\nAction: MarkAsDone\nTimestamp: ${timestampMs}`;

// retry/cancel are FORWARDED unchanged to signing, which reconstructs these multi-field strings
// (admin_transfer_actions.go:184/191) and verifies against <FROM_PROVIDER>_ADMIN_MONITOR_EVM_ADDRESSES.
// Every field is read off the row — never hardcode. chainId is rendered as an integer.
export const buildRetryMessage = (row: TransferItem, timestamp: number) => {
  const chainIdInt = parseInt(String(row.fromChainId), 10);
  return (
    `RetryFailedTransfer\n` +
    `TransferID: ${row.id}\n` +
    `Provider: ${row.fromProvider}\n` +
    `ChainID: ${chainIdInt}\n` +
    `TokenAddress: ${row.fromToken}\n` +
    `ToAddress: ${row.toAddress}\n` +
    `Amount: ${row.fromAmount}\n` +
    `Timestamp: ${timestamp}`
  );
};

export const buildCancelMessage = (row: TransferItem, timestamp: number) =>
  `CancelFailedTransfer\n` +
  `TransferID: ${row.id}\n` +
  `Provider: ${row.fromProvider}\n` +
  `Timestamp: ${timestamp}`;
